import {
    Action,
    ActionType,
    DatasourceEnum,
    Interpretation,
} from "#services/pilotService/types";
import React from "react";
import { H3, P } from "#common/headings";
import { Card, Button, Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "#store";
import {
    selectInterpretationsById,
    selectOperatorInvocationsRawByIds,
} from "#selectors";
import { Tabs, TabType } from "#common/Tabs";
import { DataCartListingSimple } from "#pages/results/DataCartListingSimple";
import { RadarContainer } from "#pages/results/RadarContainer";
import { IoStateComponentHoc } from "#common/io/IoStateComponentHOC";
import { isPresent } from "#types";
import { setInterpretationFav, setQuery } from "#store/ui";
import { OperatorInvocationsListing } from "#components/Model/OperatorInvocation/OperatorInvocationsListing";
import { InterpretationsListingByOperatorInvocations } from "#components/Model/OperatorInvocation/InterpretationsListingByOperatorInvocations";
import { isDone } from "#store/types";
import { push } from "redux-first-history";
import { generateUrl } from "#components/App/routing/generateUrl";
import { generatePath } from "react-router";
import { Routes } from "#/config";
import { FavoriteAddIcon } from "#components/icons/favorites";

export const ActionView = (action: Action) => {
    const dispatch = useAppDispatch();
    const currentQuery = action.query;
    const datasourceDto = useAppSelector(
        state => state.uiState.selectedDatasource
    );
    const currentDatasource = datasourceDto.name;

    const operatorInvocations = useAppSelector(state =>
        selectOperatorInvocationsRawByIds(state, action.operatorInvocation)
    );
    const presentOps = operatorInvocations
        .filter(isPresent)
        .filter(isDone)
        .map(x => x.payload)
        .filter(isPresent);

    const interpretationCount = presentOps
        .map(x => x.rawInterpretationCount)
        .reduce((a, b) => a + b, 0);
    const i: Interpretation[] = useAppSelector(state =>
        selectInterpretationsById(
            state,
            presentOps.flatMap(x => x.interpretations)
        )
    );

    const [value, setValue] = React.useState(
        // "Find projects where Alberto Broggi was involved."
        currentQuery || ""
    );

    const currentOp = ActionType.NL2SQL;

    const onSubmit = (
        q: string = value,
        datasource: DatasourceEnum = currentDatasource,
        op: ActionType = currentOp
    ) => {
        dispatch(setQuery(q));
        dispatch(
            push(
                generateUrl(generatePath(Routes.triggerAction.path), {
                    q: q,
                    op: op,
                    o: datasourceDto.queryLanguage,
                    db: datasource,
                })
            )
        );
    };

    const navigationTabs: TabType[] = [
        {
            label: "Data Library",
            content: (
                <>
                    <Button
                        variant={"outlined"}
                        endIcon={<FavoriteAddIcon />}
                        onClick={() => {
                            i.forEach(x =>
                                dispatch(setInterpretationFav(x.id, true))
                            );
                        }}
                    >
                        Add all {i.length} interpretations to data library
                    </Button>
                    <DataCartListingSimple />
                </>
            ),
        },
        { label: "Radar", content: <RadarContainer interpretations={i} /> },
        // { label: "Column", content: <Todo> Add Columns</Todo> },
    ];

    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={9}>
                    <H3>Search results for "{action.query}"</H3>
                    <P>
                        Your <i>{action.actionType}</i> action triggered{" "}
                        {action.operatorInvocation.length} systems on datasource{" "}
                        <i>{action.datasource}</i>.
                    </P>{" "}
                    <br />
                    <InterpretationsListingByOperatorInvocations
                        operatorInvocationIds={action.operatorInvocation}
                    />
                    <br />
                    <OperatorInvocationsListing
                        ops={action.operatorInvocation}
                    />
                </Grid>
                <Grid item md={3}>
                    <Card
                        sx={{
                            position: "sticky",
                            top: "5rem",
                        }}
                    >
                        <Tabs tabs={navigationTabs} defaultTab={0} />
                    </Card>
                </Grid>
            </Grid>
        </>
    );
};
export const ActionViewIo = IoStateComponentHoc<Action>(ActionView);
